import React from 'react'

const AdminVideoStatus = ({ cell, row }) => {
    const isDisapproved = cell === 2 || row?.active === 2 || row?.status === 2;
    const isPublished = cell === 1 || cell === "PUBLISHED";
    const isScheduled = cell === "SCHEDULED";
    const isUnpublished = cell === "UNPUBLISHED";
    
    const statusText = isDisapproved ? "DISAPPROVED" : cell;
    const statusClass = isPublished ? "PUBLISHED_active" : isScheduled ? "DISABLED_active" : "UNPUBLISHED_active";
    
    return (
        <div className={`d-inline-flex justify-content-center px-3 py-1 w-75 text-center ${statusClass}`} >
            <p className='' style={{ fontSize: "10px", fontWeight: "700" }}>{statusText}</p>
        </div>
    )
}

export default AdminVideoStatus